import React from 'react'
import ModelContext from '../contexts/ModelContext'

export default function useModel () {
  return React.useContext(ModelContext)
}
